export default "__VITE_ASSET__Ccc1hVxm__"